import { render } from "./organizationDetailPanel.vue?vue&type=template&id=7cca8ee8&scoped=true"
import script from "./organizationDetailPanel.vue?vue&type=script&lang=js"
export * from "./organizationDetailPanel.vue?vue&type=script&lang=js"

import "./organizationDetailPanel.vue?vue&type=style&index=0&id=7cca8ee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cca8ee8"]])

export default __exports__